<template>
    <div 
        class="score-label flex items-center gap-1.5 px-2 py-1 rounded-[8px] shadow-custom bg-white"
        data-cy="container_score_label"
        :style="positionStyle"
    >
        <img 
            :src="icon" 
            :alt="label" 
            class="w-5 h-5 flex-shrink-0"
            data-cy="icon_score_label"
        />
        <span class="text-16 text-a-black whitespace-nowrap" data-cy="text_score_label">
            {{ label }} : <span class="font-normal" data-cy="text_score_label_value">{{ score }}</span>/<span data-cy="text_score_label_max">{{ maxScore }}</span>
        </span>
    </div>
</template>

<script>
export default {
    name: "ScoreLabel",
    props: {
        // Icon image source
        icon: {
            type: String,
            required: true
        },
        // Label text (e.g., "Spend", "Save")
        label: {
            type: String,
            required: true
        },
        // Current score value
        score: {
            type: Number,
            default: 0
        },
        // Maximum score
        maxScore: {
            type: Number,
            default: 100
        },
        // Position object { top, right, left, bottom } in px or percentages
        position: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        positionStyle() {
            const style = {
                position: 'absolute',
                zIndex: 10
            };
            
            if (this.position.top !== undefined) {
                style.top = typeof this.position.top === 'number' 
                    ? `${this.position.top}px` 
                    : this.position.top;
            }
            if (this.position.right !== undefined) {
                style.right = typeof this.position.right === 'number' 
                    ? `${this.position.right}px` 
                    : this.position.right;
            }
            if (this.position.left !== undefined) {
                style.left = typeof this.position.left === 'number' 
                    ? `${this.position.left}px` 
                    : this.position.left;
            }
            if (this.position.bottom !== undefined) {
                style.bottom = typeof this.position.bottom === 'number' 
                    ? `${this.position.bottom}px` 
                    : this.position.bottom;
            }
            
            return style;
        }
    }
};
</script>

<style scoped>
.shadow-custom {
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.25);
}
</style>
